import { BaseService, Service } from "/@/cool";

@Service("orderV2")
class OrderV2 extends BaseService {
	constructor() {
		super();

		let prefix = "";
		if (this.namespace) {
			prefix = this.namespace.replace(/\//g, ":") + ":";
		}

		this.permission["confirm"] = prefix + "confirm";
		this.permission["cancel"] = prefix + "cancel";
		this.permission["printTicket"] = prefix + "printTicket";
		this.permission["checkIfNeedHang"] = prefix + "checkIfNeedHang";
		this.permission["checkIfNeedHangV2"] = prefix + "checkIfNeedHangV2";
	}

	confirm(params: any) {
		return this.request({
			url: "/confirm",
			method: "POST",
			data: {
				...params
			}
		});
	}

	cancel(params: any) {
		return this.request({
			url: "/cancel",
			method: "POST",
			data: {
				...params
			}
		});
	}

	shopTicketInfo(params: any) {
		return this.request({
			url: "/printTicket",
			method: "get",
			params
		});
	}
	checkIfNeedHang(params: any) {
		return this.request({
			url: "/checkIfNeedHang",
			method: "get",
			params
		});
	}
	checkIfNeedHangV2(params: any) {
		return this.request({
			url: "/checkIfNeedHangV2",
			method: "get",
			params
		});
	}
}

export default OrderV2;
